import type { TTransportSubtype, TTransportType } from 'api/swagger';
import type { ETripAssignment } from 'types/transport';
import { createStore } from './create-store';

export interface ITransportFilter {
  type?: TTransportType;
  subTypes?: TTransportSubtype[];
  subcontractor?: 'none' | 'any' | number[];
  needService?: boolean;
  inService?: boolean;
  notUsed?: boolean;
  tripAssignment?: ETripAssignment;
}

type TState = {
  search: string;
  filters?: ITransportFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: ITransportFilter | undefined) => void;
};

export const useTransportFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: ITransportFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'transport-filters-store',
);
